export default __webpack_public_path__ + "static/media/foto9.b9e3e73b.jpg";